import { useLocation } from '@tanstack/react-router'
import { TailSpin } from 'react-loader-spinner'

import { useSession } from '../_hooks/use-session'
import { Sidebar } from './sidebar'

export const DashboardSidebar = () => {
  const { status } = useSession()
  const { pathname: path } = useLocation()

  if (!path.includes('/login') && status === 'loading') {
    return (
      <div className="flex w-[240px] items-center justify-center">
        <TailSpin ariaLabel="Carregando..." color="#00A180" width={40} height={40} />
      </div>
    )
  }

  if (path.includes('/login')) {
    return null
  }

  return <Sidebar />
}
